import { render, staticRenderFns } from "./changeMailModal.vue?vue&type=template&id=9e945356&"
import script from "./changeMailModal.vue?vue&type=script&lang=ts&"
export * from "./changeMailModal.vue?vue&type=script&lang=ts&"
import style0 from "./changeMailModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports